import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        heading: 'New bot',
        headingUpdate: 'Update bot',
        paragraph: 'Enter the details below',
        botInput: {
            text: 'Bot name',
            placeholder: 'My bot name',
            errorMessageText: 'Invalid name, must contain atleast three characters' 
        },
        descriptionTextArea: {
            text: 'Description',
            placeholder: 'This bot is used for...',
            errorMessageText: 'Invalid description, must contain atleast three characters' 
        },
        languagesSelect: [{
            value: 'en',
            name: 'English'
        }, {
            value: 'es',
            name: 'Spanish'
        }],
        button: {
            text: 'Create bot',
            textUpdate: 'Update bot'
        }
    },
    es: {
        heading: 'Nuevo Bot',
        headingUpdate: 'Actualiza el bot',
        paragraph: 'Ingresa los siguientes datos',
        botInput: {
            text: 'Nombre del bot',
            placeholder: 'El nombre de mi bot',
            errorMessageText: 'Nombre inválido, debe tener al menos 3 letras' 
        },
        descriptionTextArea: {
            text: 'Descripción',
            placeholder: 'Este bot se usa para...',
            errorMessageText: 'Descripción inválida, debe tener al menos 3 letras' 
        },
        languagesSelect: [{
            value: 'es',
            name: 'Español'
        }, {
            value: 'en',
            name: 'Inglés'
        }, {
            value: 'sv',
            name: 'Sueco'
        }],
        button: {
            text: 'Crear bot',
            textUpdate: 'Actualizar bot'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCreateBot/FormCreateBotContent.js